import { currencyFormat } from 'common/helpers/numberHelper';

const VariantSelector = (props) => {
  const { product, selectedVariant, settings, onVariantChange } = props;

  if (product.variants.length <= 1) {
    return null;
  }
  const handleVariantChange = (e) => {
    onVariantChange(e.target.value);
  };
  return (
    <select
      className="c7-product__variant__select"
      name="variantId"
      value={selectedVariant.id}
      onChange={handleVariantChange}
    >
      {renderOptionArray(product.variants, settings)}
    </select>
  );
};

export default VariantSelector;

const renderOptionArray = (variants, settings) =>
  variants.map((variant) => (
    <option key={variant.id} value={variant.id}>
      {variant.title} {currencyFormat(variant.addToCartPrice, settings)}
    </option>
  ));
